import { TextFieldRoot, TextFieldLabel, TextField } from "@/components/shadcn/textfield";
import { DatePicker } from "@/components/shadcn/date-picker";
import dayjs from "dayjs";

export function DateInput(props) {

  const onInput = (date) => {
    props.input?.(props.name, date.toISOString().split('T')[0]);
  }

  const value = (date) => {
    return dayjs(date);
  }

  return (
    <TextFieldRoot class="space-y-0">
      <TextFieldLabel class={props.sr ? 'sr-only mb-1' : ''}>{props.label}</TextFieldLabel>
      <DatePicker inputClass="w-full flex" onChange={onInput} disabled={props.disabled} value={value(props.form[props.name])} />
    </TextFieldRoot>
  );
}
